<template>
  <div class="widget-error">
    <div v-if="error == 'NotAllowedError'" class="widget-error__container">
      <img src="@/img/undraw_microphone.svg" alt="allow device microphone">
      <p class="widget-error__description">
        HiperMe needs access to the computer's microphone. Please check the browser settings and allow access to the microphone
      </p>
    </div>
    <div v-if="error == 'NoCaptureDevice'" class="widget-error__container">
      <img src="@/img/undraw_microphone.svg" alt="no capture device">
      <p class="widget-error__description">
        To use the widget, please connect a microphone.
      </p>
    </div>
    <div v-if="error == 'ExtensionRegisterError'" class="widget-error__container">
      <img src="@/img/undraw_warning_tl76.svg" alt="extension register error">
      <p class="widget-error__description">
        An error occurred while registering the extension. Please reload the page and try again.
      </p>
    </div>
    <slot name="buttons"></slot>
  </div>
</template>
<script>
export default {
  name: "WidgetError",
  props: {
    error: {
      type: String,
      default: null
    }
  }
}

</script>
<style scoped>
.widget-error {
  height: 440px;
  width: 100%;
}
.widget-error__container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  height: 100%;
  font-size: 0.9em;
}
.widget-error .widget-error__description {
  text-align: center;
}
.widget-error img{
  width: 70%;
  height: auto;
}
</style>